import { FC, useEffect } from 'react';

const DefaultRedirect: FC = () => {
  useEffect(() => {
    window.location.href = 'https://www.settrade.com/th/';
  }, []);

  return <div></div>;
};

export default DefaultRedirect;
